var _desc, _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTerritoires(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Landscape--Streamline-Atlas",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.75 -0.75 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Landscape Streamline Icon: https://streamlinehq.com\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.021875 20.625 20.45625 0",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.453125 11.671875 2.3718749999999997 -2.3718749999999997a2.053125 2.053125 0 0 1 1.4625000000000001 -0.609375 2.0250000000000004 2.0250000000000004 0 0 1 1.453125 0.609375L18.065625 20.625",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.25 13.809375000000001 1.9500000000000002 -1.9593749999999999a2.0812500000000003 2.0812500000000003 0 0 1 1.4625000000000001 -0.6 2.0625 2.0625 0 0 1 1.453125 0.6l5.3625 5.3625",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54375 4.003125a2.128125 2.128125 0 1 0 4.25625 0 2.128125 2.128125 0 1 0 -4.25625 0",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTerritoires);
export default __webpack_public_path__ + "static/media/icon-territoires.2c05f2a0ead68b3e74eea2d0eb52b1fa.svg";
export { ForwardRef as ReactComponent };